import dayjs from 'dayjs';

export const fetchTranscriptsEvents = (request, { isoDate, signal }) =>
  request({
    method: 'get',
    pathname: `/api/transcriber/get-events?isoDate=${dayjs(isoDate).format('YYYY-MM-DD')}`,
    signal,
  });

export const fetchTranscriptsDebates = (request, { isoDate, signal }) =>
  request({
    method: 'get',
    pathname: `/api/transcriber/get-debates?isoDate=${dayjs(isoDate).format('YYYY-MM-DD')}`,
    signal,
  });

export const createDiarisedTranscript = (request, { signal, ...data }) =>
  request({
    method: 'post',
    pathname: `/api/transcriber/create-diarised-transcript`,
    data,
    signal,
  });

export const updateDiarisedTranscript = (request, { signal, ...data }) =>
  request({
    method: 'post',
    pathname: `/api/transcriber/update-diarised-transcript`,
    data,
    signal,
  });

export const fetchListTranscripts = (request, { signal, ...params }) =>
  request({
    method: 'get',
    pathname: `/api/transcriber/list-transcripts`,
    params,
    signal,
  });

export const fetchDownloadTranscript = (request, { id, signal }) =>
  request({
    method: 'get',
    pathname: `/api/transcriber/download-transcript`,
    params: { id },
    responseType: 'blob',
    signal,
  });

export const deleteTranscript = (request, { id, signal }) =>
  request({
    method: 'delete',
    pathname: `/api/transcriber/delete-transcript`,
    params: { id },
    signal,
  });
